import moment from 'moment';

export const locations = [
    {
        "name": "Default",
        "latitude": 0,
        "longitude": 0,
        "offset": 0,
        "image": "gmt_0p.jpg"
    },
    {
        "name": "Custom",
        "latitude": 0,
        "longitude": 0,
        "offset": 0,
    },
    {
        "name": "Amsterdam",
        "latitude": 419,
        "longitude": 39,
        "offset": 4,
        "image": "gmt_1p.jpg"
    },
    {
        "name": "Andorra",
        "latitude": 340,
        "longitude": 12,
        "offset": 4,
        "image": "gmt_1p.jpg"
    },
    {
        "name": "Ankara",
        "latitude": 319,
        "longitude": 263,
        "offset": 8,
        "image": "gmt_2p.jpg"
    },
    {
        "name": "Athens",
        "latitude": 304,
        "longitude": 190,
        "offset": 8,
        "image": "gmt_2p.jpg"
    },
    {
        "name": "Atlanta, GA",
        "latitude": 270,
        "longitude": 64860,
        "offset": 108,
        "image": "gmt_5m.jpg"
    },
    {
        "name": "Austin, TX",
        "latitude": 242,
        "longitude": 64753,
        "offset": 104,
        "image": "gmt_6m.jpg"
    },
    {
        "name": "Baku",
        "latitude": 323,
        "longitude": 399,
        "offset": 16,
        "image": "gmt_4p.jpg"
    },
    {
        "name": "Belgrade",
        "latitude": 359,
        "longitude": 164,
        "offset": 4,
        "image": "gmt_1p.jpg"
    },
    {
        "name": "Berlin",
        "latitude": 420,
        "longitude": 107,
        "offset": 4,
        "image": "gmt_1p.jpg"
    },
    {
        "name": "Bern",
        "latitude": 376,
        "longitude": 60,
        "offset": 4,
        "image": "gmt_1p.jpg"
    },
    {
        "name": "Bogota",
        "latitude": 36,
        "longitude": 64943,
        "offset": 108,
        "image": "gmt_5m.jpg"
    },
    {
        "name": "Brasilia",
        "latitude": 65409,
        "longitude": 65153,
        "offset": 116,
        "image": "gmt_3m.jpg"
    },
    {
        "name": "Bratislava",
        "latitude": 385,
        "longitude": 137,
        "offset": 4,
        "image": "gmt_1p.jpg"
    },
    {
        "name": "Brussels",
        "latitude": 407,
        "longitude": 35,
        "offset": 4,
        "image": "gmt_1p.jpg"
    },
    {
        "name": "Bucharest",
        "latitude": 355,
        "longitude": 209,
        "offset": 8,
        "image": "gmt_2p.jpg"
    },
    {
        "name": "Budapest",
        "latitude": 380,
        "longitude": 152,
        "offset": 4,
        "image": "gmt_1p.jpg"
    },
    {
        "name": "Buenos Aires",
        "latitude": 65259,
        "longitude": 65068,
        "offset": 116,
        "image": "gmt_3m.jpg"
    },
    {
        "name": "Cape Town",
        "latitude": 65265,
        "longitude": 147,
        "offset": 8,
        "image": "gmt_2p.jpg"
    },
    {
        "name": "Cheyenne, WY",
        "latitude": 329,
        "longitude": 64697,
        "offset": 100,
        "image": "gmt_7m.jpg"
    },
    {
        "name": "Chicago, IL",
        "latitude": 335,
        "longitude": 64834,
        "offset": 108,
        "image": "gmt_5m.jpg"
    },
    {
        "name": "Chisinau",
        "latitude": 376,
        "longitude": 231,
        "offset": 8,
        "image": "gmt_2p.jpg"
    },
    {
        "name": "Copenhagen",
        "latitude": 446,
        "longitude": 101,
        "offset": 4,
        "image": "gmt_1p.jpg"
    },
    {
        "name": "Dubai",
        "latitude": 202,
        "longitude": 442,
        "offset": 16,
        "image": "gmt_4p.jpg"
    },
    {
        "name": "Dublin",
        "latitude": 427,
        "longitude": 65486,
        "offset": 0,
        "image": "gmt_0p.jpg"
    },
    {
        "name": "Geneva",
        "latitude": 370,
        "longitude": 49,
        "offset": 4,
        "image": "gmt_1p.jpg"
    },
    {
        "name": "Helsinki",
        "latitude": 481,
        "longitude": 200,
        "offset": 8,
        "image": "gmt_2p.jpg"
    },
    {
        "name": "Istanbul",
        "latitude": 328,
        "longitude": 232,
        "offset": 8,
        "image": "gmt_2p.jpg"
    },
    {
        "name": "Kiev",
        "latitude": 403,
        "longitude": 244,
        "offset": 8,
        "image": "gmt_2p.jpg"
    },
    {
        "name": "Lima",
        "latitude": 65439,
        "longitude": 64919,
        "offset": 108,
        "image": "gmt_5m.jpg"
    },
    {
        "name": "Lisbon",
        "latitude": 310,
        "longitude": 65463,
        "offset": 0,
        "image": "gmt_0p.jpg"
    },
    {
        "name": "Ljubljana",
        "latitude": 369,
        "longitude": 116,
        "offset": 4,
        "image": "gmt_1p.jpg"
    },
    {
        "name": "London",
        "latitude": 412,
        "longitude": 65535,
        "offset": 0,
        "image": "gmt_0p.jpg"
    },
    {
        "name": "Luxembourg",
        "latitude": 397,
        "longitude": 49,
        "offset": 4,
        "image": "gmt_1p.jpg"
    },
    {
        "name": "Lyon",
        "latitude": 366,
        "longitude": 39,
        "offset": 4,
        "image": "gmt_1p.jpg"
    },
    {
        "name": "Madrid",
        "latitude": 323,
        "longitude": 65506,
        "offset": 4,
        "image": "gmt_1p.jpg"
    },
    {
        "name": "Marseilles",
        "latitude": 346,
        "longitude": 43,
        "offset": 4,
        "image": "gmt_1p.jpg"
    },
    {
        "name": "Melbourne",
        "latitude": 65234,
        "longitude": 1160,
        "offset": 40,
        "image": "gmt_10p.jpg"
    },
    {
        "name": "Minsk",
        "latitude": 431,
        "longitude": 220,
        "offset": 8,
        "image": "gmt_2p.jpg"
    },
    {
        "name": "Monaco",
        "latitude": 350,
        "longitude": 59,
        "offset": 4,
        "image": "gmt_1p.jpg"
    },
    {
        "name": "Moscow",
        "latitude": 446,
        "longitude": 300,
        "offset": 16,
        "image": "gmt_4p.jpg"
    },
    {
        "name": "Munich",
        "latitude": 385,
        "longitude": 93,
        "offset": 4,
        "image": "gmt_1p.jpg"
    },
    {
        "name": "New Delhi",
        "latitude": 229,
        "longitude": 618,
        "offset": 22,
        "image": "gmt_5.5p.jpg"
    },
    {
        "name": "New York, NY",
        "latitude": 325,
        "longitude": 64943,
        "offset": 108,
        "image": "gmt_5m.jpg"
    },
    {
        "name": "Nicosia",
        "latitude": 281,
        "longitude": 267,
        "offset": 8,
        "image": "gmt_2p.jpg"
    },
    {
        "name": "Olympia, WA",
        "latitude": 376,
        "longitude": 64552,
        "offset": 96,
        "image": "gmt_8m.jpg"
    },
    {
        "name": "Oslo",
        "latitude": 479,
        "longitude": 86,
        "offset": 4,
        "image": "gmt_1p.jpg"
    },
    {
        "name": "Paris",
        "latitude": 391,
        "longitude": 19,
        "offset": 4,
        "image": "gmt_1p.jpg"
    },
    {
        "name": "Phoenix, AZ",
        "latitude": 267,
        "longitude": 64640,
        "offset": 100,
        "image": "gmt_7m.jpg"
    },
    {
        "name": "Prague",
        "latitude": 401,
        "longitude": 115,
        "offset": 4,
        "image": "gmt_1p.jpg"
    },
    {
        "name": "Reykjavik",
        "latitude": 513,
        "longitude": 65360,
        "offset": 0,
        "image": "gmt_0p.jpg"
    },
    {
        "name": "Riga",
        "latitude": 455,
        "longitude": 193,
        "offset": 8,
        "image": "gmt_2p.jpg"
    },
    {
        "name": "Riyadh",
        "latitude": 197,
        "longitude": 373,
        "offset": 12,
        "image": "gmt_3p.jpg"
    },
    {
        "name": "Rome",
        "latitude": 335,
        "longitude": 100,
        "offset": 4,
        "image": "gmt_1p.jpg"
    },
    {
        "name": "San Marino",
        "latitude": 351,
        "longitude": 99,
        "offset": 4,
        "image": "gmt_1p.jpg"
    },
    {
        "name": "Salvador da Bahia",
        "latitude": 65432,
        "longitude": 65228,
        "offset": 116,
        "image": "gmt_3m.jpg"
    },
    {
        "name": "San Diego, CA",
        "latitude": 261,
        "longitude": 64599,
        "offset": 96,
        "image": "gmt_8m.jpg"
    },
    {
        "name": "Sao Paulo",
        "latitude": 65348,
        "longitude": 65163,
        "offset": 116,
        "image": "gmt_3m.jpg"
    },
    {
        "name": "Sarajevo",
        "latitude": 351,
        "longitude": 147,
        "offset": 4,
        "image": "gmt_1p.jpg"
    },
    {
        "name": "Shanghai",
        "latitude": 250,
        "longitude": 972,
        "offset": 32,
        "image": "gmt_8p.jpg"
    },
    {
        "name": "Skopja",
        "latitude": 336,
        "longitude": 172,
        "offset": 4,
        "image": "gmt_1p.jpg"
    },
    {
        "name": "Sofia",
        "latitude": 341,
        "longitude": 186,
        "offset": 8,
        "image": "gmt_2p.jpg"
    },
    {
        "name": "Stockholm",
        "latitude": 475,
        "longitude": 145,
        "offset": 4,
        "image": "gmt_1p.jpg"
    },
    {
        "name": "Sydney",
        "latitude": 65265,
        "longitude": 1209,
        "offset": 40,
        "image": "gmt_10p.jpg"
    },
    {
        "name": "Tallinn",
        "latitude": 475,
        "longitude": 198,
        "offset": 8,
        "image": "gmt_2p.jpg"
    },
    {
        "name": "Tbilisi",
        "latitude": 334,
        "longitude": 358,
        "offset": 16,
        "image": "gmt_4p.jpg"
    },
    {
        "name": "Tel Aviv",
        "latitude": 257,
        "longitude": 278,
        "offset": 12,
        "image": "gmt_3p.jpg"
    },
    {
        "name": "Tirana",
        "latitude": 331,
        "longitude": 159,
        "offset": 4,
        "image": "gmt_1p.jpg"
    },
    {
        "name": "Vaduz",
        "latitude": 377,
        "longitude": 76,
        "offset": 4,
        "image": "gmt_1p.jpg"
    },
    {
        "name": "Valletta",
        "latitude": 287,
        "longitude": 116,
        "offset": 4,
        "image": "gmt_1p.jpg"
    },
    {
        "name": "Vienna",
        "latitude": 386,
        "longitude": 131,
        "offset": 4,
        "image": "gmt_1p.jpg"
    },
    {
        "name": "Vilnius",
        "latitude": 437,
        "longitude": 203,
        "offset": 8,
        "image": "gmt_2p.jpg"
    },
    {
        "name": "Warsaw",
        "latitude": 418,
        "longitude": 168,
        "offset": 4,
        "image": "gmt_1p.jpg"
    },
    {
        "name": "Yerevan",
        "latitude": 321,
        "longitude": 356,
        "offset": 16,
        "image": "gmt_4p.jpg"
    },
    {
        "name": "Zagreb",
        "latitude": 366,
        "longitude": 128,
        "offset": 4,
        "image": "gmt_1p.jpg"
    }
];

// -----------

const timeZones = [
    {
        "zone": "(UTC-12:00) International Date Line West",
        "image": "gmt_12m.jpg"
    },
    {
        "zone": "(UTC-11:00) Coordinated Universal Time-11",
        "image": "gmt_11m.jpg"
    },
    {
        "zone": "(UTC-10:00) Hawaii",
        "image": "gmt_10m.jpg"
    },
    {
        "zone": "(UTC-09:00) Alaska",
        "image": "gmt_9m.jpg"
    },
    {
        "zone": "(UTC-08:00) Pacific Time (US & Canada)",
        "image": "gmt_8m.jpg"
    },
    {
        "zone": "(UTC-07:00) Mountain Time (US & Canada)",
        "image": "gmt_7m.jpg"
    },
    {
        "zone": "(UTC-06:00) Saskatchewan",
        "image": "gmt_6m.jpg"
    },
    {
        "zone": "(UTC-05:00) Eastern Time (US & Canada)",
        "image": "gmt_5m.jpg"
    },
    {
        "zone": "(UTC-04:30) Caracas",
        "image": "gmt_4.5m.jpg"
    },
    {
        "zone": "(UTC-04:00) Atlantic Time (Canada)",
        "image": "gmt_4m.jpg"
    },
    {
        "zone": "(UTC-03:30) Newfoundland",
        "image": "gmt_3.5m.jpg"
    },
    {
        "zone": "(UTC-03:00) Buenos Aires",
        "image": "gmt_3m.jpg"
    },
    {
        "zone": "(UTC-02:00) Mid-Atlantic",
        "image": "gmt_2m.jpg"
    },
    {
        "zone": "(UTC-01:00) Azores",
        "image": "gmt_1m.jpg"
    },
    {
        "zone": "(UTC) Dublin, Edinburgh, Lisbon, London",
        "image": "gmt_0p.jpg"
    },
    {
        "zone": "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
        "image": "gmt_1p.jpg"
    },
    {
        "zone": "(UTC+02:00) E. Europe",
        "image": "gmt_2p.jpg"
    },
    {
        "zone": "(UTC+03:00) Kuwait, Riyadh",
        "image": "gmt_3p.jpg"
    },
    {
        "zone": "(UTC+03:30) Tehran",
        "image": "gmt_3.5p.jpg"
    },
    {
        "zone": "(UTC+04:00) Abu Dhabi, Muscat",
        "image": "gmt_4p.jpg"
    },
    {
        "zone": "(UTC+04:30) Kabul",
        "image": "gmt_4.5p.jpg"
    },
    {
        "zone": "(UTC+05:00) Islamabad, Karachi",
        "image": "gmt_5p.jpg"
    },
    {
        "zone": "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
        "image": "gmt_5.5p.jpg"
    },
    {
        "zone": "(UTC+05:45) Kathmandu",
        "image": "gmt_5.75p.jpg"
    },
    {
        "zone": "(UTC+06:00) Dhaka",
        "image": "gmt_6p.jpg"
    },
    {
        "zone": "(UTC+06:30) Yangon (Rangoon)",
        "image": "gmt_6.5p.jpg"
    },
    {
        "zone": "(UTC+07:00) Novosibirsk",
        "image": "gmt_7p.jpg"
    },
    {
        "zone": "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
        "image": "gmt_8p.jpg"
    },
    {
        "zone": "(UTC+09:00) Seoul",
        "image": "gmt_9p.jpg"
    },
    {
        "zone": "(UTC+09:30) Darwin",
        "image": "gmt_9.5p.jpg"
    },
    {
        "zone": "(UTC+10:00) Canberra, Melbourne, Sydney",
        "image": "gmt_10p.jpg"
    },
    {
        "zone": "(UTC+11:00) Solomon Is., New Caledonia",
        "image": "gmt_11p.jpg"
    },
    {
        "zone": "(UTC+12:00) Fiji",
        "image": "gmt_12p.jpg"
    },
    {
        "zone": "(UTC+13:00) Samoa",
        "image": "gmt_13p.jpg"
    }
];

function getTimeZoneOffsetValue(zoneName) {

    const tmpValue = getTimeZoneUTcValueFromName(zoneName).split(':');

    const hourValue = parseInt(tmpValue[0].replace("UTC", ''));
    const minutesValue = tmpValue.length === 2
        ? ('' + (parseInt(tmpValue[1]) / 0.6)).padEnd(2, '0')
        : '00';

    return parseFloat(`${hourValue}.${minutesValue}`);
}
function getTimeZoneUTcValueFromName(zoneName) {

    if (!zoneName) {
        return '';
    }

    const utcValue = zoneName.match(/\(([^)]*)\)/)[1];

    if (utcValue === 'UTC') {
        return utcValue + "+00:00";
    }

    return utcValue;
}

export function displayValueofTimeZones(tempTimeZonesOffSet) {

    const displaytimezonesvalue = [];
    for (var i = 0; i < timeZones.length; i++) {

        const time = timeZones[i];

        if (true) {
            if (+getTimeZoneOffsetValue(time.zone) + 3 >= getOffsetFromLongitude(tempTimeZonesOffSet) && +getTimeZoneOffsetValue(time.zone) - 3 <= getOffsetFromLongitude(tempTimeZonesOffSet)) {
                displaytimezonesvalue.push(getTimeZoneUTcValueFromName(time.zone));
            }
        }
        else {
            displaytimezonesvalue.push(getTimeZoneUTcValueFromName(time.zone));
        }
    }

    return displaytimezonesvalue;
}

function getOffsetFromLongitude(longitude) {
    return +((((Math.trunc((+longitude + 180.0) / 15.0 + 0.5)) - 12) << 16) >> 16);
}

// LocationVM:536

// -----------

// LocationDataBL:89
export function calculateMidnightShift(selectedOffset, selectedLatitude, selectedLongitude) {
    let sunset = 0;
    let sunrise = 0;
    let accumulatedShift = 0;
    let dateTimeRepeat = new Date((new Date()).getFullYear(), 0, 1);

    for (let i = 1; i <= 366; i++) {
        const sunlocationCurrentDay = getSunLocation(dateTimeRepeat, selectedOffset, selectedLatitude, selectedLongitude);
        const sunlocationNextDay = getSunLocation(moment(dateTimeRepeat).add(1, 'days').toDate(), selectedOffset, selectedLatitude, selectedLongitude);

        if (sunlocationCurrentDay != null && sunlocationNextDay != null) {
            sunset = sunlocationCurrentDay.set;
            sunrise = sunlocationNextDay.rise;
        }

        dateTimeRepeat.setDate(dateTimeRepeat.getDate() + 1);
        const nightLength = 24 + sunrise - sunset;
        const virtualMidnight = sunset + (nightLength / 2);
        const midnightshift = virtualMidnight - 24;
        accumulatedShift += midnightshift;
    }

    const res = Math.round(accumulatedShift * 60 / 366);

    return res ? res + 1 : 0;
}

function getSunLocation(scheduleDate, selectedOffset, selectedLatitude, selectedLongitude) {
    return calcSunrise(scheduleDate, selectedOffset, selectedLatitude, selectedLongitude);
}

function calcSunrise(today, timeOffset, latitude, longitude) {

    const dayMoment = moment(today);
    return {
        rise: sunRise(dayMoment.year(), dayMoment.month() + 1, dayMoment.date(), latitude, longitude, timeOffset),
        set: sunSet(dayMoment.year(), dayMoment.month() + 1, dayMoment.date(), latitude, longitude, timeOffset),
    };
}

function sunRise(year, month, day, lat, lon, timezone) {
    let num = 900.0;
    let num2 = 0.0 - num;
    const num3 = 86400.0;
    let hour;
    let min;
    let sec;
    do {
        num2 += num;
        hour = Math.trunc(num2 / 3600.0);
        min = Math.trunc(num2 % 3600.0 / 60.0);
        sec = Math.trunc(num2) % 60;
    }
    while (sunPosition(year, month, day, hour, min, sec, lat, lon, timezone) > 0.0 && num2 > num3);
    let num4 = num2 - num;
    do {
        num4 += num;
        hour = Math.trunc(num4 / 3600.0);
        min = Math.trunc(num4 % 3600.0 / 60.0);
        sec = Math.trunc(num4) % 60;
    }
    while ((sunPosition(year, month, day, hour, min, sec, lat, lon, timezone) < 0.0 || num4 < num2) && num4 < num3);
    if (num2 <= num3 && num4 <= num3) {
        num = num4 - num2;
        num2 += num / 2.0;
        while (num > 1.0) {
            num /= 2.0;
            hour = Math.trunc(num2 / 3600.0);
            min = Math.trunc(num2 % 3600.0 / 60.0);
            sec = Math.trunc(num2) % 60;
            if (sunPosition(year, month, day, hour, min, sec, lat, lon, timezone) > 0.0) {
                num2 -= num;
            }
            else {
                num2 += num;
            }
        }

        return num2 / 3600.0;
    }

    return null;
}

function sunSet(year, month, day, lat, lon, timezone) {
    let num = 900.0;
    const num2 = 0.0;
    let num3 = 86400.0 + num;
    let hour;
    let min;
    let sec;
    do {
        num3 -= num;
        hour = Math.trunc(num3 / 3600.0);
        min = Math.trunc(num3 % 3600.0 / 60.0);
        sec = Math.trunc(num3) % 60;
    }
    while (sunPosition(year, month, day, hour, min, sec, lat, lon, timezone) > 0.0 && num3 > num2);
    let num4 = num3 + num;
    do {
        num4 -= num;
        hour = Math.trunc(num4 / 3600.0);
        min = Math.trunc(num4 % 3600.0 / 60.0);
        sec = Math.trunc(num4) % 60;
    }
    while ((sunPosition(year, month, day, hour, min, sec, lat, lon, timezone) < 0.0 || num4 > num3) && num4 > num2);
    if (num4 >= num2 && num3 >= num2) {
        num = num3 - num4;
        num4 += num / 2.0;
        while (num > 1.0) {
            num /= 2.0;
            hour = Math.trunc(num4 / 3600.0);
            min = Math.trunc(num4 % 3600.0 / 60.0);
            sec = Math.trunc(num4) % 60;
            if (sunPosition(year, month, day, hour, min, sec, lat, lon, timezone) > 0.0) {
                num4 += num;
            }
            else {
                num4 -= num;
            }
        }

        return num4 / 3600.0;
    }

    return null;
}

function sunPosition(year, month, day, hour, min, sec, lat, lon, timezone) {
    const num = dayOfYear((new Date()).getFullYear(), 12, 31);
    let num2 = dayOfYear(year, month, day);
    let num3 = hour + 0.016666666666666666 * min + 0.00027777777777777778 * sec - timezone + 1.0;
    num3 -= 4.0 * (15.0 - lon) / 60.0;
    num2 = (num2 * 360.0 / num + num3 / 24.0);
    const grad1 = 0.3948 - 23.2559 * Math.cos(rad(num2 + 9.1)) - 0.3915 * Math.cos(rad(2.0 * num2 + 5.4)) - 0.1764 * Math.cos(rad(3.0 * num2 + 26.0));
    const num4 = 0.0066 + 7.3525 * Math.cos(rad(num2 + 85.9)) + 9.9359 * Math.cos(rad(2.0 * num2 + 108.9)) + 0.3387 * Math.cos(rad(3.0 * num2 + 105.2));
    const num5 = num3 + num4 / 60.0;
    const grad2 = (12.0 - num5) * 15.0;
    let num6 = Math.cos(rad(grad2)) * Math.cos(rad(lat)) * Math.cos(rad(grad1)) + Math.sin(rad(lat)) * Math.sin(rad(grad1));
    num6 = (num6 > 1.0) ? 1.0 : ((num6 < -1.0) ? -1.0 : num6);
    const num7 = grad(Math.asin(num6));
    // let num8 = (Math.sin(rad(num7)) * Math.sin(rad(lat)) - Math.sin(rad(grad1))) / (Math.cos(rad(num7)) * Math.cos(rad(lat)));
    // num8 = (num8 > 1.0) ? 1.0 : ((num8 < -1.0) ? -1.0 : num8);
    // let num9 = grad(Math.acos(num8));
    // if (num5 > 12.0 || num5 < 0.0) {
    //    num9 = 180.0 + num9;
    // }
    // else {
    //    num9 = 180.0 - num9;
    // }

    return Math.round(num7 * 1000.0) / 1000.0;
}

function grad(rad) {
    return rad * 180.0 / 3.1415926536;
}

function rad(grad) {
    return grad * 3.1415926536 / 180.0;
}

function dayOfYear(year, month, day) {
    const now = new Date();
    const start = new Date(year, month, day);
    const diff = (now - start) + ((start.getTimezoneOffset() - now.getTimezoneOffset()) * 60 * 1000);
    const oneDay = 1000 * 60 * 60 * 24;

    return Math.floor(diff / oneDay);
}
